import BaseApi from './baseApi';
import IWarehouseContacts from '../models/IWarehouseContacts';
import IAuthentication from '../models/IAuthentication';
export default class WarehouseContactsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Warehouses");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetWarehouseContacts(warehouseId: string) : Promise<IWarehouseContacts[]> {
        const json = this.getJsonRead(warehouseId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var warehouseContacts: IWarehouseContacts[] = [];
            warehouseContacts = response.data as IWarehouseContacts[];
            return warehouseContacts;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveWarehouseContact(warehouseContact: IWarehouseContacts) : Promise<string> {
        const json = this.getJsonSave(warehouseContact);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateWarehouseContact(warehouseContact: IWarehouseContacts) : Promise<boolean> {
        const json = this.getJsonUpdate(warehouseContact);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteWarehouseContact(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "WarehousesContacts",
            "conditions": [{
                "Item1": "WarehousesContacts",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(warehouseContact: IWarehouseContacts) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": warehouseContact.name
            }, {
                "Item1": "Email",
                "Item2": warehouseContact.email
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": warehouseContact.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": warehouseContact.phoneNumber
            }, {
                "Item1": "IdWarehouse",
                "Item2": warehouseContact.idWarehouse
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "WarehousesContacts"
        };
        return json;
    }

    private getJsonUpdate(warehouseContact: IWarehouseContacts) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": warehouseContact.name
            }, {
                "Item1": "Email",
                "Item2": warehouseContact.email
            }, {
                "Item1": "IdListPhonePrefix",
                "Item2": warehouseContact.idListPhonePrefix
            }, {
                "Item1": "PhoneNumber",
                "Item2": warehouseContact.phoneNumber
            }, {
                "Item1": "IdWarehouse",
                "Item2": warehouseContact.idWarehouse
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "WarehousesContacts",
            "keyvalue": warehouseContact.id
        };
        return json;
    }

    private getJsonRead(warehouseId: string) : any {
        const json = {
            "fields": [{
                "Item1": "WarehousesContacts",
                "Item2": "id"
            }, {
                "Item1": "WarehousesContacts",
                "Item2": "name"
            }, {
                "Item1": "WarehousesContacts",
                "Item2": "email"
            }, {
                "Item1": "WarehousesContacts",
                "Item2": "idListPhonePrefix"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }, {
                "Item1": "WarehousesContacts",
                "Item2": "phoneNumber"
            }, {
                "Item1": "WarehousesContacts",
                "Item2": "idWarehouse"
            }],
            "tables": [{
                "Item1": "WarehousesContacts"
            }, {
                "Item1": "ListPhonePrefixes"
            }],
            "joins": [{
                "Item1": "WarehousesContacts",
                "Item2": "IdListPhonePrefix",
                "Item3": "ListPhonePrefixes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "WarehousesContacts",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "WarehousesContacts",
                "Item2": "IdWarehouse",
                "Item3": "=",
                "Item4": warehouseId
            }]
        };
        return json;
    }
}
